module.exports = __webpack_public_path__ + "media/images/icons/tick-blue-no-border-c139259b7e95e436dd3956a99c2f7ecd.svg";